<template>
  <div>
    <!-- <force-read></force-read> -->
    <van-popup
      v-model="forceRead"
      round
      class="inPop forceRead"
    >
    <!-- 如果我已阅读按钮要滑到屏幕底部才展示，将.forceRead的overflow: hidden和.base_color的height去掉 -->
      <component
        :is="forceReadFile"
        :hidePopup="hideForcePopup"
      ></component>
      <div @click="forceReadSure" class="forceReadBtn" :class="forceReadText !== '我已阅读' ? 'disable' : ''">{{forceReadText}}</div>
    </van-popup>
    <van-popup
      v-model="show"
      round
      class="inPop"
    >
      <component
        :is="contract"
        :hidePopup="hidePopup"
      ></component>
    </van-popup>
    <div class="agreement">
      <img
        class="selectImg"
        @click="clickAgree()"
        :src="imgUrlAgreement"
        alt=""
      >
      <span
        class="agreementText"
        @click="clickAgree()"
      >{{text}}</span>
      <!-- <br/> -->
      <span
        class="agreement_content"
        @click="showClick(item.value)"
        v-for="item in list"
        :key="item.value"
      >《{{ item.text }}》</span>
    </div>
  </div>
</template>
<script>
import EnterpriseAuthorizationAgreement from '@/components/FeildTwo/components/EnterpriseAuthorizationAgreement.vue';
import BSDAuthorizationAgreement from '@/components/FeildTwo/components/BSDAuthorizationAgreement.vue';
import IndividualAuthorizationAgreement from '@/components/FeildTwo/components/IndividualAuthorizationAgreement.vue';
import PaiUserAuthorizationAgreement from '@/components/FeildTwo/components/PaiUserAuthorizationAgreement.vue';
import DashuH5 from '@/components/FeildTwo/components/DashuH5.vue';
import GuaranteeServiceContract from '@/components/FeildTwo/components/GuaranteeServiceContract.vue';
import PersonalAuthorizedAgreement from '@/components/FeildTwo/components/PersonalAuthorizedAgreement.vue';
import InformationCheckAndUseAgreement from '@/components/FeildTwo/components/InformationCheckAndUseAgreement.vue';
import PufaOnlineAuth from '@/components/FeildTwo/components/PufaOnlineAuth.vue';
import PufaStatementUse from '@/components/FeildTwo/components/PufaStatementUse.vue';
import pufaPrivacyAgreement from '@/components/FeildTwo/components/pufaPrivacyAgreement.vue';
import pufaServiceAgreement from '@/components/FeildTwo/components/pufaServiceAgreement.vue';
import registerAgreement from '@/components/FeildTwo/components/registerAgreement.vue';
import DaShuInfoContract from '@/components/FeildTwo/components/DaShuInfoContract.vue';
import suningEnterpriseCreditauthorize from '@/components/FeildTwo/components/suningEnterpriseCreditauthorize.vue'; // 苏宁 --《企业征信查询授权书》
import suningPersonalCreditAuthorize from '@/components/FeildTwo/components/suningPersonalCreditAuthorize.vue'; // 苏宁 --《个人征信查询授权书》
import suningPersonalInfoAuthorize from '@/components/FeildTwo/components/suningPersonalInfoAuthorize.vue'; // 苏宁 --《隐私及综合信息查询授权书
import yxEnterpriseInfomationAgree from '@/components/FeildTwo/components/yxEnterpriseInfomationAgree.vue';
import Privacypolicy from '@/components/FeildTwo/components/Privacypolicy.vue';
import AuthorizationContract from '@/components/FeildTwo/components/AuthorizationContract.vue';
import YiLianJKContract from '@/components/FeildTwo/components/YiLianJKContract.vue';
import YiLianKKAuth from '@/components/FeildTwo/components/YiLianKKAuth.vue';
import YiLianSXEDContract from '@/components/FeildTwo/components/YiLianSXEDContract.vue';
import YiLianUserInfoQueryAuth from '@/components/FeildTwo/components/YiLianUserInfoQueryAuth.vue';
import YiLianUserZXAuth from '@/components/FeildTwo/components/YiLianUserZXAuth.vue';
import YiLianDBFWContract from '@/components/FeildTwo/components/YiLianDBFWContract.vue';
import YlPowerAttorneyContract from '@/components/FeildTwo/components/YlPowerAttorneyContract.vue';
import YlJilinYilianBankContract from '@/components/FeildTwo/components/YlJilinYilianBankContract.vue';

// 苏宁 --《最高额保证合同》
import suningMaximumGuaranteeContract from '@/components/FeildTwo/components/suningMaximumGuaranteeContract.vue';
// 苏宁 --《发票贷借款合同（企业版）》
import suningInvoiceLoanEnterprise from '@/components/FeildTwo/components/suningInvoiceLoanEnterprise.vue';
// 敏感个人信息处理授权书
import YiLianSensitiveAuthorizationLetter from '@/components/FeildTwo/components/YiLianSensitiveAuthorizationLetter.vue';

import NoSelect from '@/assets/images/weixuanzhong.png';
import Select from '@/assets/images/xuanzhong.png';

import ForceReadEnterpriseAuthorizationAgreementPaiUserAuthorizationAgreement from '@/components/ForceRead/ForceReadEnterpriseAuthorizationAgreementPaiUserAuthorizationAgreement.vue';
import ForceReadPufaOnlineAuthPufaStatementUse from '@/components/ForceRead/ForceReadPufaOnlineAuthPufaStatementUse.vue';
import ForceReadYiLianKKAuthYiLianJKContract from '@/components/ForceRead/ForceReadYiLianKKAuthYiLianJKContract.vue';
import ForceReadYlJilinYilianBankContractYiLianJKContract from '@/components/ForceRead/ForceReadYlJilinYilianBankContractYiLianJKContract.vue';
import ForceReadYiLianUserInfoQueryAuthYiLianUserZXAuth from '@/components/ForceRead/ForceReadYiLianUserInfoQueryAuthYiLianUserZXAuth.vue';
import ForceReadsuningInvoiceLoanEnterprisesuningMaximumGuaranteeContract from '@/components/ForceRead/ForceReadsuningInvoiceLoanEnterprisesuningMaximumGuaranteeContract.vue';
import ForceReadYiLianUserInfoQueryAuthYiLianUserZXAuthYiLianSensitiveAuthorizationLetterYlPowerAttorneyContract from '@/components/ForceRead/ForceReadYiLianUserInfoQueryAuthYiLianUserZXAuthYiLianSensitiveAuthorizationLetterYlPowerAttorneyContract.vue';
import ForceReadYiLianKKAuthYiLianDBFWContract from '@/components/ForceRead/ForceReadYiLianKKAuthYiLianDBFWContract.vue';

let clearIv = null;
export default {
  name: 'Contract',
  props: {
    list: Array,
    text: {
      type: String,
      default: '本人已经阅读并完全同意：',
    },
    isForceRead: {
      default: '',
    },
    counts: {
      default: 5,
    },
    value: Boolean,
    defaultCheck: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      forceReadText: '我已阅读',
      forceReadFileArr: [],
      forceReadFile: '',
      forceRead: false,
      agreeWithAgreement: this.defaultCheck,
      contract: '',
      show: false,
      imgUrlAgreement: this.defaultCheck ? Select : NoSelect,
      agreeMap: {
        // bw_sq: 'YlPowerAttorneyContract',
        bw_sq: 'EnterpriseAuthorizationAgreement',
        bsd_sq: 'BSDAuthorizationAgreement', 
        pzz_sq:'PaiUserAuthorizationAgreement',
        gr_sq:'IndividualAuthorizationAgreement',
        dashu_h5: 'DashuH5',
        pds_sq: 'PersonalAuthorizedAgreement',
        pds_invoice: 'InformationCheckAndUseAgreement',
        spdb_pi: 'PufaOnlineAuth',
        spdb_uspec: 'PufaStatementUse',
        pufa_privacy: 'pufaPrivacyAgreement',
        pufa_service: 'pufaServiceAgreement',
        REGISTERAGREEMENT: 'registerAgreement',
        spdb_guarantee: 'GuaranteeServiceContract',
        dashu_info_contract: 'DaShuInfoContract',
        suningEnterpriseCreditauthorize: 'suningEnterpriseCreditauthorize',
        suningPersonalCreditAuthorize: 'suningPersonalCreditAuthorize',
        suningPersonalInfoAuthorize: 'suningPersonalInfoAuthorize',
        yx_entInfo_sq: 'yxEnterpriseInfomationAgree',
        Privacypolicy: 'Privacypolicy',
        AuthorizationContract: 'AuthorizationContract',
        suningMaximumGuaranteeContract: 'suningMaximumGuaranteeContract',
        suningInvoiceLoanEnterprise: 'suningInvoiceLoanEnterprise',
        yl_sq: 'YiLianUserInfoQueryAuth',
        yl_zxsq: 'YiLianUserZXAuth',
        YiLianJKContract: 'YiLianJKContract',
        YiLianKKAuth: 'YiLianKKAuth',
        YiLianSXEDContract: 'YiLianSXEDContract',
        yl_db: 'YiLianDBFWContract',
        yl_si: 'YiLianSensitiveAuthorizationLetter',
        yl_qysq: 'YlPowerAttorneyContract',
        yl_zfwt: 'YlJilinYilianBankContract',
      },
    };
  },

  components: {
    EnterpriseAuthorizationAgreement,
    BSDAuthorizationAgreement,
    IndividualAuthorizationAgreement,
    DashuH5,
    PersonalAuthorizedAgreement,
    InformationCheckAndUseAgreement,
    PufaStatementUse,
    PufaOnlineAuth,
    pufaPrivacyAgreement,
    pufaServiceAgreement,
    registerAgreement,
    GuaranteeServiceContract,
    DaShuInfoContract,
    suningEnterpriseCreditauthorize,
    suningPersonalCreditAuthorize,
    suningPersonalInfoAuthorize,
    yxEnterpriseInfomationAgree,
    Privacypolicy,
    AuthorizationContract,
    suningMaximumGuaranteeContract,
    suningInvoiceLoanEnterprise,
    YiLianJKContract,
    YiLianKKAuth,
    YiLianSXEDContract,
    YiLianUserInfoQueryAuth,
    YiLianUserZXAuth,
    YiLianDBFWContract,
    PaiUserAuthorizationAgreement,
    ForceReadEnterpriseAuthorizationAgreementPaiUserAuthorizationAgreement,
    ForceReadPufaOnlineAuthPufaStatementUse,
    ForceReadYiLianKKAuthYiLianJKContract,
    ForceReadYiLianUserInfoQueryAuthYiLianUserZXAuth,
    ForceReadsuningInvoiceLoanEnterprisesuningMaximumGuaranteeContract,
    YiLianSensitiveAuthorizationLetter,
    ForceReadYiLianUserInfoQueryAuthYiLianUserZXAuthYiLianSensitiveAuthorizationLetterYlPowerAttorneyContract,
    ForceReadYiLianKKAuthYiLianDBFWContract,
    YlPowerAttorneyContract,
    YlJilinYilianBankContract,
    ForceReadYlJilinYilianBankContractYiLianJKContract,
  },
  mounted() {
    this.list.forEach((e) => {
      this.forceReadFileArr.push(this.agreeMap[e.value]);
    });
    // 单个协议用现有，多个需要合并的协议拼接名称
    if (this.forceReadFileArr.length > 1) {
      this.forceReadFile = `ForceRead${this.forceReadFileArr.join('')}`;
    } else {
      this.forceReadFile = this.forceReadFileArr.join('');
    }
    console.log('协议---', this.forceReadFile);
  },
  methods: {
    forceReadSure() {
      if (this.forceReadText !== '我已阅读') return;
      this.agreeWithAgreement = !this.agreeWithAgreement;
      this.imgUrlAgreement = this.agreeWithAgreement ? Select : NoSelect;
      this.$emit('input', this.agreeWithAgreement);

      this.forceRead = false;
      clearInterval(clearIv);
    },
    clickAgree() {
      /**
       ***进件第一步信息认证页所有产品均强制阅读
          进件第二步个别产品，仅浦发需要强制阅读
          是浦发流程但是签署担保合同页不需要强制阅读
          --- isForceRead加了强类型判断是由于有中间状态''
      */
      if (this.isForceRead === true || (this.$route.query.productId === 'SPDB-FPD' && this.isForceRead !== false) || this.$route.query.productId === 'YL-YPD') {
        if (!this.agreeWithAgreement) {
          this.count = this.counts;
          this.forceRead = true;
          this.forceReadText = `我已阅读(${this.count--})`;
          clearIv = setInterval(() => {
            if (this.count > 0) {
              this.forceReadText = `我已阅读(${this.count--})`;
            } else {
              this.forceReadText = '我已阅读';
            }
          }, 1000);
        } else {
          // this.count = !this.agreeWithAgreement ? 5 : 0;
          this.forceReadSure();
        }
      } else {
        this.agreeWithAgreement = !this.agreeWithAgreement;
        this.imgUrlAgreement = this.agreeWithAgreement ? Select : NoSelect;
        this.$emit('input', this.agreeWithAgreement);
      }
    },
    showClick(val) {
      this.$emit('showPopup', this.agreeMap[val]);
      this.showPopup(this.agreeMap[val]);
    },
    showPopup(val) {
      this.contract = val;
      this.show = !this.show;
    },
    hidePopup() {
      this.show = !this.show;
    },
    hideForcePopup() {
      this.forceRead = !this.forceRead;
      this.count = this.counts;
      clearInterval(clearIv);
    },
  },
};
</script>
<style scoped>
.inPop {
  width: 90%;
  height: 90%;
  padding: 10px;
}
.forceRead {
  padding-bottom: 50px;
  overflow: hidden;
}
.forceReadBtn {
  background: #ff6538;
  color: #fff;
  border-radius: 4px;
  padding: 8px;
  text-align: center;
}
.disable {
  background: #d7d7d7;
}

.inPop >>> .inPop a#close {
  background: none;
  color: #000;
}

.agreement {
  box-sizing: border-box;
  margin-top: 10px;
  margin: 0 15px 0 15px;
  color: #9ea7b4;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: left;
  position: relative;
}
.agreement .agreement_content {
  color: #ff6538;
}
.selectImg {
  width: 12px;
  position: absolute;
  top: 5px;
  left: 0;
}
.seletedColor {
  color: #ff6538;
}
.agreementText {
  margin-left: 20px;
}
</style>
